
import React, { useState, useEffect } from 'react';
import './App.css';
import Intro from './components/intro';
import BfFormstep11 from './components/step1';
import BfFormstep12 from './components/step-1-2';
import BfFormstep13 from './components/step-1-3'; 
import BfFormstep21 from './components/step-2-1';
import BfFormstep22 from './components/step-2-2';
import BfFormstep23 from './components/step-2-3'; 
import bfFormstep31 from './components/step-3-1';
import BfFormstep32 from './components/step-3-2';
import BfFormstep33 from './components/step-3-3';
import ThankYou from './components/thankyou';


import './scss/main.scss'
import BfFormstep31 from './components/step-3-1';

const initialFormData = {
  step11: {},
  step22: {},
  step12: {},
  step13: {},
  step32: {},
};
function App() {
  const [lang, setLang] = useState('eng');
  useEffect(() => {
    window.history.pushState({}, '', '/buses/apply-now');
}, []);

  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState(initialFormData);
  const [recaptchaValue, setRecaptchaValue] = useState("e");

  const [vehicleIndexToEdit, setVehicleIndexToEdit] = useState(null);
  const [driverIndexToEdit, setDriverIndexToEdit] = useState(null);
  const [driverIndexToDisplay, setDriverIndexToDisplay] = useState(null);
  const [vehicleIndexToDisplay, setVehicleIndexToDisplay] = useState(null);
  const [didItSend, setDidItSend] = useState(false);

  const nextStep = async () => {
  

    setCurrentStep(currentStep + 1);
  }
  const nextStepby2 = async () => {
    setCurrentStep(currentStep + 2);
  }

  const backStep = async () => {
    setCurrentStep(currentStep - 1);


  }
  const backStepby2 = async () => {
    setCurrentStep(currentStep - 2);
 

  }
  const backStepby3 = async () => {
    setCurrentStep(currentStep - 3);
 
  }


//update step 11 data
  const updateStep11Data = (newData) => {

   const formattedeffectivedate =  
     newData.owners_policy_effective_date instanceof Date && !isNaN(newData.owners_policy_effective_date)
      ? `${(newData.owners_policy_effective_date.getMonth() + 1).toString().padStart(2, '0')}/${newData.owners_policy_effective_date.getDate().toString().padStart(2, '0')}/${newData.owners_policy_effective_date.getFullYear()}`
        : '';

    setFormData((prevData) => ({
      ...prevData,
      step11: {
        ...(prevData.step11 || {}),
        ...newData,
        [ 'owners_policy_effective_date']:formattedeffectivedate
      },
    }));
  }

  //update step 12 data
  const updateStep12Data = (newData) => {
    setFormData((prevData) => ({
      ...prevData,
      step12: {
        ...(prevData.step12 || {}),
        ...newData,
      },
    }));
  }
  const convertDriverDataToArray = (data) => {
    const driversArray = [];
    let i = 0;

    while (data[`drivers[${i}]first name`] !== undefined) {
        driversArray.push({
            "first_name": data[`drivers[${i}]first name`],
            "last_name": data[`drivers[${i}]last name`],
            "middle_name": data[`drivers[${i}]middle name`],
            "dob": data[`drivers[${i}]dob`],
            "license_no": data[`drivers[${i}]license no`],
            "issued_state_mx": data[`drivers[${i}]issued state mx`],
            "expiration_date": data[`drivers[${i}]expiration date`],
            //add is_foreigner
            "is_foreigner": data[`drivers[${i}]is foreigner`],
            //add country_origin\
            "country_origin": data[`drivers[${i}]country origin`],
        });
        i++;
    }

    return driversArray;
}


// Convert vehicle data from flat format to array format
const convertVehicleDataToArray = (data) => {
  const vehiclesArray = [];
  let i = 0;

  while (data[`vehicles[${i}]year`] !== undefined) {
      vehiclesArray.push({
          "year": data[`vehicles[${i}]year`],
          "make": data[`vehicles[${i}]make`],
          "model": data[`vehicles[${i}]model`],
          "vin": data[`vehicles[${i}]vin`],
          "radius_operation": data[`vehicles[${i}]radius_operation`],
          "value": data[`vehicles[${i}]value`]
      });
      i++;
  }

  return vehiclesArray;
}

  //update step 13 data
  const updateStep13Data = async (newData) => {
    // Existing functionality: merging new data into step13
    setFormData((prevData) => ({
      ...prevData,
      step13: {
        ...(prevData.step13 || {}),
        ...newData,
      },
    }));


  }
  /*    // Extracting data from the steps
  */
//create usestate if currentstep = 10, then create finaldata and send finaldata to api

  const [driverCount, setDriverCount] = useState(0);
  //find the highest index in the drivers array
  const findHighestIndex = (data) => {
    let highestIndex = -1;

    for (const key in data) {
      if (key.startsWith("drivers[")) {
        const indexStr = key.split("]")[0].split("[")[1];
        const index = parseInt(indexStr, 10);
        highestIndex = Math.max(highestIndex, index);
      }
    }

    return highestIndex;
  };

  const findHighestVehicleIndex = (data) => {
    let highestIndex = -1;

    for (const key in data) {
      if (key.startsWith("vehicles[")) {
        const indexStr = key.split("]")[0].split("[")[1];
        const index = parseInt(indexStr, 10);
        highestIndex = Math.max(highestIndex, index);
      }
    }
    return highestIndex;
  }

  const updateStep22Data = (newData) => {
    //find the highest index in the drivers array2
 
    const indextoadd = findHighestIndex(formData.step22);
    const fieldNamePrefix = driverIndexToEdit !== null ? `drivers[${driverIndexToEdit}]` : `drivers[${indextoadd + 1}]`;

    const formattedExpirationDate =
        newData.expirationDate instanceof Date && !isNaN(newData.expirationDate)
            ? `${(newData.expirationDate.getMonth() + 1).toString().padStart(2, '0')}/${newData.expirationDate.getDate().toString().padStart(2, '0')}/${newData.expirationDate.getFullYear()}`
            : '';

    const formattedDob =  
        newData.dob instanceof Date && !isNaN(newData.dob)
            ? `${(newData.dob.getMonth() + 1).toString().padStart(2, '0')}/${newData.dob.getDate().toString().padStart(2, '0')}/${newData.dob.getFullYear()}`
            : '';

    const updatedStep22Data = {
        [`${fieldNamePrefix}first name`]: newData.firstName,
        [`${fieldNamePrefix}last name`]: newData.lastName,
        [`${fieldNamePrefix}middle name`]: newData.middleName,
        [`${fieldNamePrefix}dob`]: formattedDob,
        [`${fieldNamePrefix}license no`]: newData.licenseNumber,
        [`${fieldNamePrefix}issued state mx`]: newData.issuedStateMx,
        [`${fieldNamePrefix}expiration date`]: formattedExpirationDate,
        //add is_foreigner
        [`${fieldNamePrefix}is foreigner`]: newData.is_foreigner,
        //add country_origin  
        [`${fieldNamePrefix}country origin`]: newData.country_origin,
    };

    setFormData((prevData) => ({
        ...prevData,
        step22: {
            ...(prevData.step22 || {}),
            ...updatedStep22Data,
        },
    }));

    // Increment the driver count only if adding a new driver
    if(driverIndexToEdit === null) {
        setDriverCount(driverCount + 1);
    } else {
        // Reset the driverIndexToEdit
        setDriverIndexToEdit(null);
    }
};

  
  
  const [vehicleCount, setVehicleCount] = useState(0);
  //update step 32 data, which is the same as step 22 but with vehicles instead of drivers
  const updateStep32Data = (newData) => {
    const highestIndex = findHighestVehicleIndex(formData.step32);
    

    const fieldNamePrefix = vehicleIndexToEdit !== null ? `vehicles[${vehicleIndexToEdit}]` : `vehicles[${highestIndex + 1}]`;
    
    const updatedStep32Data = {};

    // Map the provided fields to the new structure
    updatedStep32Data[`${fieldNamePrefix}year`] = newData.year;
    updatedStep32Data[`${fieldNamePrefix}make`] = newData.make;
    updatedStep32Data[`${fieldNamePrefix}model`] = newData.model;
    updatedStep32Data[`${fieldNamePrefix}vin`] = newData.vin;
    updatedStep32Data[`${fieldNamePrefix}radius_operation`] = newData.radius_operation;
    updatedStep32Data[`${fieldNamePrefix}value`] = newData.value;

    setFormData((prevData) => ({
        ...prevData,
        step32: {
            ...(prevData.step32 || {}),
            ...updatedStep32Data,
        },
    }));

    // Increment the vehicle count only if adding a new vehicle
    if(vehicleIndexToEdit === null) {
        setVehicleCount(vehicleCount + 1);
    } else {
        // Reset the vehicleIndexToEdit
        setVehicleIndexToEdit(null);
    }
};

const sendData = async () => {
  console.log("sending data")
  const { step11, step22, step12, step13, step32 } = formData;

    const driversArray = convertDriverDataToArray(step22);
    const vehiclesArray = convertVehicleDataToArray(step32);
    

    const step12Modified = {
      ...step12,
      business_activities_list_ports: step12.business_activities_list_ports.join(", "),
      business_activities_cities_visited: step12.business_activities_cities_visited.join(", "),
      business_activities_type_business_company: step12.business_activities_type_business_company.join(", "),
  };
    // Constructing the final data
    const finalData = {
        "phone": step11.owners_business_phone,
        "email": step11.owners_email,
        ...step11,
        ...step12Modified,
        ...step13,
        drivers: driversArray,
        vehicles: vehiclesArray,
        "code": "BLFBUSES",
        "media_code": lang === 'eng'? "BLFIRE-GRAL-CSYS-WS-E-00198" : "BLFIRE-GRAL-CSYS-WS-S-00199",
        //"recaptcha_response": recaptchaValue,
        "recaptcha_response": "asdfzxc666789",
        recaptcha_response_score: "2",
        "last_name": step11.owners[0].last_name,
        "first_name": step11.owners[0].first_name,
        "language": lang === 'eng' ? 'ENGLISH' : 'SPANISH'

    };

  
    try {
      const response = await fetch(`${process.env.REACT_APP_URL_API_ZODIAC}/api/recruit/blf-buses/save/v1`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(finalData)
      });

      const result = await response.json();

      console.log("Data sent successfully:", result);
    } catch (error) {
      console.error("Error sending data:", error);
    }
}
  
  return (
    <>

    {/*currentStep === 0 && ( <Intro lang={lang} setLang={setLang} nextStep={nextStep} />  )*/}
    {currentStep === 0 && ( <BfFormstep11 lang={lang} setLang={setLang} formData={formData} updateFormData={updateStep11Data} nextStep={nextStep} backStep={backStep} backStepby2={backStepby2} nextStepby2={nextStepby2}/>  )}
    {currentStep === 1 && ( <BfFormstep12 lang={lang} setLang={setLang} formData={formData.step12} updateFormData={updateStep12Data} nextStep={nextStep} backStep={backStep} backStepby2={backStepby2} nextStepby2={nextStepby2}/>  )}
    {currentStep === 2 && ( <BfFormstep21 lang={lang} setLang={setLang} formData={formData} nextStep={nextStep} backStep={backStep} backStepby2={backStepby3} nextStepby2={nextStepby2}/> )}
    {currentStep === 3 && ( <BfFormstep22 driverIndexToDisplay={driverIndexToDisplay} lang={lang} setLang={setLang} driverIndexToEdit={driverIndexToEdit} driverDisplayIndex={driverCount + 1} setDriverIndexToEdit={setDriverIndexToEdit} formData={formData} updateFormData={updateStep22Data} nextStep={nextStep} backStep={backStep} backStepby2={backStepby2} nextStepby2={nextStepby2}/>  )}
    {currentStep === 4 && ( <BfFormstep23 setDriverIndexToDisplay={setDriverIndexToDisplay} lang={lang} setLang={setLang} setDriverIndexToEdit={setDriverIndexToEdit} setDriverCount={setDriverCount} setFormData={setFormData} driverCount={driverCount} formData={formData} nextStep={nextStep} backStep={backStep} backStepby2={backStepby3} nextStepby2={nextStepby2}/>  )}
    {currentStep === 5 && ( <BfFormstep31 lang={lang} setLang={setLang} formData={formData} nextStep={nextStep} backStep={backStep} backStepby2={backStepby2} nextStepby2={nextStepby2}/> )}
    {currentStep === 6 && ( <BfFormstep32 vehicleIndexToDisplay={vehicleIndexToDisplay} lang={lang} setLang={setLang} vehicleDisplayIndex={vehicleCount + 1} setVehicleIndexToEdit={setVehicleIndexToEdit} formData={formData} vehicleIndexToEdit={vehicleIndexToEdit} updateFormData={updateStep32Data} nextStep={nextStep} backStep={backStep} backStepby2={backStepby2} nextStepby2={nextStepby2}/>  )}
    {currentStep === 7 && ( <BfFormstep33 setVehicleIndexToDisplay={setVehicleIndexToDisplay} lang={lang} setLang={setLang} setVehicleIndexToEdit={setVehicleIndexToEdit} setVehicleCount={setVehicleCount} setFormData={setFormData} vehicleCount={vehicleCount} formData={formData} nextStep={nextStep} backStep={backStep} backStepby2={backStepby3} nextStepby2={nextStepby2}/> )}
    {currentStep === 8 && ( <BfFormstep13 setRecaptchaValue={setRecaptchaValue} lang={lang} setLang={setLang} updateFormData={updateStep13Data} formData={formData.step13} nextStep={nextStep} backStep={backStep} backStepby2={backStepby2} nextStepby2={nextStepby2}/>  )}
    {currentStep === 9 && ( <ThankYou didItSend={didItSend} setDidItSend={setDidItSend} sendData={sendData} backstep={backStep} lang={lang} setLang={setLang} formData={formData}/> )}
      

     
    
</>
  );
}

export default App;
